// Configuración centralizada de endpoints de la API
import { environment } from '../../../../environments/environment';

const BASE = environment.apiBaseUrl;

export const API_ENDPOINTS = {
  // Autenticación.
  auth: {
    token: `${environment.auth.authBaseDomain}${environment.auth.tokenEndpoint}`,
  },

  // Leads (gateway de integraciones SURA)
  leads: {
    create: `${BASE}/clientes/autos/lead`,
    update: (leadId: string) => `${BASE}/clientes/autos/updateLead/${leadId}`,
    exception: (leadId: string) => `${BASE}/clientes/exceptionMovilidad?lead_id=${leadId}`,
  },

  // Consulta de datos de vehículo
  vehicleLookup: {
    get: (leadId: string) => `${BASE}/clientes/autos/updateLead/${leadId}`,
  },

  // Tarifas de planes de autos
  tarifas: {
    planes: `${BASE}/tarifas/planes/autos`,
  },

  // Catálogo (pais y zona circulacion)
  catalogs: {
    countries: `${BASE}/catalogos/paises`,
    circulationZones: `${BASE}/catalogos/zonas`,
  },

  // Asesores SURA
  advisors: {
    list: `${BASE}/cotizacion/SURA_OrquestadorAsesores`,
    get: (code: string) => `${BASE}/cotizacion/SURA_OrquestadorAsesores/${code}`,
  },

  // Pago (PlacetoPay vía membresía)
  payments: {
    start: `${BASE}/clientes/membresiaservice`,
    token: `${BASE}/clientes/membresiatokenservice`,
  },

  // Facturas pendientes
  pendingInvoices: {
    list: (userId: string) => `${BASE}/clientes/consultaFactura/${userId}`,
  },

  // SARLAFT 4.0 
  sarlaft: {
    start: `${BASE}/clientes/startsarlaftevaluation`,
    poll: `${BASE}/clientes/pullersarlaft`,
  },

  // Validación de cúmulo — URL
  cumulo: {
    validate: `${BASE}/sura-service/cumulo`,
  },

  // Riesgos consultables
  consultableRisks: {
    check: `${BASE}/sura-service/consulta-riesgos`,
  },

  // Crear/consultar cotización final (pre-póliza) — URL confirmada en COTIZACION-AUTOS-SPEC.md.
  cotizacion: {
    create: `${BASE}/clientes/autos/cotizacion`,
    getById: (quoteId: string) => `${BASE}/clientes/autos/cotizacion/${quoteId}`,
  },

  // Vehículos
  vehicles: {
    brands: `${BASE}/vehicles/brands`,
    models: (brandId: string) => `${BASE}/vehicles/brands/${brandId}/models`,
    lookup: (plate: string) => `${BASE}/vehicles/lookup/${plate}`,
    years: `${BASE}/vehicles/years`,
  },

  // Ciudades
  cities: {
    list: `${BASE}/cities`,
    search: (query: string) => `${BASE}/cities?q=${query}`,
  },

  // Cotización
  quoter: {
    calculate: `${BASE}/quotes/calculate`,
    getById: (quoteId: string) => `${BASE}/quotes/${quoteId}`,
    plans: `${BASE}/plans`,
  },

  // Pólizas
  policies: {
    create: `${BASE}/policies`,
    getById: (policyId: string) => `${BASE}/policies/${policyId}`,
  },
} as const;
